import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CheckoutData } from '../domain/registrator';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {
  endpoint: string = environment.api_url;

  constructor(private http: HttpClient, private messageService: MessageService) {
  }
  /**
   * Sends the checkout data to the server and returns the payment URL.
   * @param checkoutData The checkout data to send.
   * @returns An observable containing the payment URL.
   */
  checkout(checkoutData: CheckoutData): Observable<HttpResponse<{ paymentUrl: string | null }>> {
    const headers = {
      'Content-Type': 'application/json'
    };
    return this.http.post<{ paymentUrl: string | null }>(`${this.endpoint}/registrations`,
      checkoutData, { headers, observe: 'response' });
  }
}
